module.exports = __webpack_public_path__ + "img/stoner_ape_club.4a8621e2.jpg";